var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPapers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.25V14.25C9 14.6478 9.15804 15.0294 9.43934 15.3107C9.72064 15.592 10.1022 15.75 10.5 15.75H15M9 8.25V6.75C9 6.35218 9.15804 5.97064 9.43934 5.68934C9.72064 5.40804 10.1022 5.25 10.5 5.25H13.9395C14.1384 5.25004 14.3291 5.32909 14.4698 5.46975L17.7803 8.78025C17.9209 8.92087 18 9.1116 18 9.3105V14.25C18 14.6478 17.842 15.0294 17.5607 15.3107C17.2794 15.592 16.8978 15.75 16.5 15.75H15M9 8.25H7.5C7.10218 8.25 6.72064 8.40804 6.43934 8.68934C6.15804 8.97064 6 9.35218 6 9.75V17.25C6 17.6478 6.15804 18.0294 6.43934 18.3107C6.72064 18.592 7.10218 18.75 7.5 18.75H13.5C13.8978 18.75 14.2794 18.592 14.5607 18.3107C14.842 18.0294 15 17.6478 15 17.25V15.75",
    stroke: "#3F3F46",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPapers);
export default __webpack_public_path__ + "static/media/Papers.25f2ea6b4664cd746a5eab4a77b469df.svg";
export { ForwardRef as ReactComponent };